import _ from "lodash";
import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import EmptyField from "UIComponents/EmptyField";
import { nanoid } from "nanoid";
import InputCheckList from "./components/InputCheckList";

class UIInputCheckList extends UIBaseComponent {
  componentDidMount = () => {
    const { value } = this.props;

    if (value.length == 0) {
      this.handleInit();
    }

    if (this.shouldShowEditEmpty()) {
      // specifically updating label to make sync between old and new UI
      this.updateValue([{ id: nanoid(10), value: "", label: "" }]);
    }
  };

  handleInit = () => {
    const {
      options,
      fieldTypeConfig: { shouldInitOptions },
    } = this.props;
    if (shouldInitOptions && options.length > 0) {
      this.updateValue(
        _.map(options, option => {
          return {
            id: option.value,
            value: option.label,
            isSelected: false,
            // specifically updating label to make sync between old and new UI
            label: option.label,
          };
        })
      );
    } else {
      this.updateValue([{ id: nanoid(10), value: "" }]);
    }
  };

  componentDidUpdate = prevProps => {
    if (
      _.get(this.props.value, "length", 0) == 0 ||
      !_.isEqualWith(
        prevProps.options,
        this.props.options,
        (oldOption, newOption) => oldOption.id == newOption.id
      )
    ) {
      this.handleInit();
    }
  };

  shouldShowEditEmpty = () => {
    const { options, shouldInitOptions } = this.props;
    if (shouldInitOptions) {
      return _.get(options, "length", 0) == 0;
    } else {
      return false;
    }
  };

  renderEditEmpty = () => {
    const { emptyText, emptyEditText } = this.props;
    return <EmptyField title={emptyEditText || emptyText} />;
  };

  renderEdit = () => {
    const { value, fieldKey, t, listType } = this.props;

    return (
      <InputCheckList
        value={value}
        dndKey={`UI_INPUT_LIST:${fieldKey}`}
        onValueChange={newArr => this.updateValue(newArr)}
        itemPlaceholder={t("common:typeHere")}
        addItemText={t("common:add_another")}
        listType={listType}
      />
    );
  };
}

UIInputCheckList.defaultProps = {
  ...UIBaseComponent.defaultProps,
};

UIInputCheckList.propTypes = {
  ...UIBaseComponent.propTypes,
};

export default I18nHOC({ resource: "common" })(UIInputCheckList);
